module.exports = __webpack_public_path__ + "img/6bd2bb4e1a75ca0ee45a52d178554e56.svg";